import { type RefObject, useLayoutEffect, useState } from 'react';

/**
 * Width of an element, kept current with a ResizeObserver. Reads the first value
 * before paint so a layout derived from it never renders once at width 0 on a
 * mounted element. 0 until the element is attached.
 */
export const useElementWidth = (ref: RefObject<HTMLElement | null>): number => {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    setWidth(element.getBoundingClientRect().width);
    const observer = new ResizeObserver(([entry]) => {
      if (entry) setWidth(entry.contentRect.width);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return width;
};
